import { escapeAttribute, escapeJsx, humanizeName } from '@cli-utils/text.js'

export function formLabelLine(
  name: string,
  label: string,
  requiredStar: string,
  className?: string
): string {
  const classes = className ?? 'text-sm font-medium leading-none'
  if (!label)
    return `<label htmlFor="${escapeAttribute(name)}" className="sr-only">${escapeJsx(humanizeName(name))}${requiredStar}</label>`
  return `<label htmlFor="${escapeAttribute(name)}" className="${classes}">${label}${requiredStar}</label>`
}
